import { Pipe, PipeTransform } from '@angular/core';
import { hasValue } from '../utilities/compare';

@Pipe({
	name: 'ifEmpty',
})
export class IfEmptyPipe implements PipeTransform {
	transform<T>(value: T, display: string = '-'): T | string {
		if (hasValue(value) && value !== '') {
			return value;
		} else {
			return display;
		}
	}
}
